import { Comp } from "@/models/CompModels";

export type State = {
  componente: Comp,
}

export const state: State = {
  componente: new Comp(),
}
